import React, { useState, useEffect, useRef, useCallback } from 'react'

export default function ContactModal({ open, onClose, onSubmit }) {
  const [nome, setNome] = useState('')
  const [contato, setContato] = useState('')
  const [mensagem, setMensagem] = useState('')
  const [status, setStatus] = useState('idle') // 'idle' | 'loading' | 'success' | 'error'
  const overlayRef = useRef(null)

  // Fechar com ESC
  useEffect(() => {
    if (!open) return
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [open, onClose])

  // Resetar status ao abrir
  useEffect(() => {
    if (open) setStatus('idle')
  }, [open])

  const handleOverlayClick = useCallback(
    (e) => {
      if (e.target === overlayRef.current) onClose()
    },
    [onClose]
  )

  const handleSubmit = useCallback(async () => {
    if (!nome.trim() || !mensagem.trim()) {
      setStatus('error')
      return
    }
    setStatus('loading')
    try {
      await onSubmit({ nome, contato, mensagem })
      setNome('')
      setContato('')
      setMensagem('')
      setStatus('success')
    } catch (err) {
      console.error(err)
      setStatus('error')
    }
  }, [nome, contato, mensagem, onSubmit])

  if (!open) return null

  return (
    <div
      ref={overlayRef}
      className="modal-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label="Fale conosco"
    >
      <div className="modal">
        <div className="modal-header">
          <h2>Fale conosco</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {status === 'success' && (
          <div className="status-msg status-success">
            ✓ Mensagem enviada! Em breve entraremos em contato.
          </div>
        )}

        {status === 'error' && (
          <div className="status-msg status-error">
            Preencha seu nome e a mensagem antes de enviar.
          </div>
        )}

        {status !== 'success' && (
          <>
            <div className="field">
              <label htmlFor="modal-nome">Seu nome</label>
              <input
                id="modal-nome"
                type="text"
                placeholder="Ex: João Silva"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                disabled={status === 'loading'}
              />
            </div>

            <div className="field">
              <label htmlFor="modal-contato">Telefone ou e-mail</label>
              <input
                id="modal-contato"
                type="text"
                placeholder="Ex: (88) 99999-9999"
                value={contato}
                onChange={(e) => setContato(e.target.value)}
                disabled={status === 'loading'}
              />
            </div>

            <div className="field">
              <label htmlFor="modal-mensagem">Mensagem</label>
              <textarea
                id="modal-mensagem"
                placeholder="Como podemos ajudar?"
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                disabled={status === 'loading'}
                rows={4}
              />
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-outline"
                onClick={onClose}
                disabled={status === 'loading'}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Enviando...' : 'Enviar mensagem'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
